import Card from '../../../components/Card';
import GlobalTradeHistory from './GlobalTradeHistory';

const ExchangeHistory = () => {
    return (
        <div className='exchange-history'>
            <Card>
                <div className='label'>Global Trade History</div>
                <GlobalTradeHistory />
            </Card>
        </div>
    );
};

export default ExchangeHistory;
